
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import HowItWorks from './components/HowItWorks';
import PricingGuide from './components/PricingGuide';
import Fleet from './components/Fleet';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <Services />
      <WhyChooseUs />
      <HowItWorks />
      <PricingGuide />
      <Fleet />
      <FAQ />
      <ContactForm />
      <Footer />
    </div>
  );
}
